// @ts-nocheck
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { URLS } from "./_config";
import requireNoAuth from "./_common/hoc/reqNoAuth";
import requireAuth from "./_common/hoc/reqAuth";
import reqLayout from "./_common/hoc/layout";
import Login from "./containers/login";
import MyProfile from "./containers/myProfile";
import RodeoEventContainer from "./containers/RodeoEvent/rodeoEvent";
import RodeoEventGameContainer from "./containers/RodeoEventGame/rodeoEventGame";
import RodeoRiderContainer from "./containers/rodeoRider/rodeoRider";
import RodeoEventLeaderBoardContainer from "./containers/rodeoLeaderBoard/rodeoEventLeaderBoard";
import AboutUsContainer from "./containers/cms/aboutUs/aboutUs";
import LegalContainer from "./containers/cms/legal/legal";
import HowToPlayContainer from "./containers/cms/howToPlay/howToPlay";
import TermOfUseContainer from "./containers/cms/termOfUse/termOfUse";
import RodeoTvImageContainer from "./containers/tv-image/tv-image";
import Page404 from "./containers/page-404";
import CacheBuster from "./CacheBuster";
import AutoLogin from "./containers/autologin";
import CmsContainer from "./containers/cms/cms";
import PrizesListContainer from "./containers/prizes-list/prizes-list";
import PrizeDetailsContainer from "./containers/prize/prize-details";
import RodeoEventPerformanceContainer from "./containers/RodeoEventPerformance/rodeoEventPerformance";
import WinningTicket from "./containers/winningTicket";
import MostPopularPicks from "./containers/mostPopularPicks";
import MyTeam from "./containers/myTeam";
import TeamImage from "./containers/teamImage";
import LandingPageContainer from "./containers/landing/landing";
import LoginWithEmail from "./containers/loginWithEmail";
import Register from "./containers/register";
import ForgotPassword from "./containers/forgot-password";
import ResetPassword from "./containers/reset-password";
import LeagueLeaderboard from "./containers/league-leaderboard";
import RodeoQnAContainer from "./containers/rodeoQnA/rodeoQnA";
import PastRodeoEventContainer from "./containers/pastRodeoEvent/pastRodeoEvent";
import ChallengeListContainer from "./containers/challengeList/challengeList";
import ChallengeDetailsContainer from "./containers/challengeDetails/challengeDetails";
import CreateChallengeContainer from "./containers/createChallenge/createChallenge";

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <React.Fragment>
            <Router>
              <Switch>
                <Route exact path={URLS.HOME} component={RodeoEventContainer} />
                <Route exact path={URLS.EVENT.PAST_RODEO_LIST} component={PastRodeoEventContainer} />
                <Route exact path={URLS.LANDING} component={LandingPageContainer} />
                <Route exact path={URLS.EVENT.LEAGUE} component={reqLayout(LeagueLeaderboard)} />
                <Route exact path={URLS.EVENT.VS_LEAGUE} component={reqLayout(LeagueLeaderboard)} />
                <Route exact path={URLS.USER.AUTO_LOGIN} component={AutoLogin} />
                <Route exact path={URLS.TV_IMAGE} component={RodeoTvImageContainer} />
                <Route exact path={URLS.USER.PROFILE} component={requireAuth(MyProfile)} />
                <Route exact path={URLS.EVENT.PERFORMANCES} component={reqLayout(RodeoEventPerformanceContainer)} />
                <Route exact path={URLS.EVENT.EVENT_GAMES} component={reqLayout(RodeoEventGameContainer)} />
                {/* <Route exact path={URLS.EVENT.RIDER_LIST} component={reqLayout(RodeoRiderContainer)} /> */}
                <Route exact path={URLS.EVENT.QUESTION_ANSWER} component={reqLayout(RodeoQnAContainer)} />
                <Route exact path={URLS.EVENT.LEADER_BOARD} component={reqLayout(RodeoEventLeaderBoardContainer)} />
                {/* <Route exact path={URLS.EVENT.LEADER_BOARD.GAME} component={reqLayout(RodeoGameLeaderBoardContainer)} /> */}
                <Route exact path={URLS.LOGIN} component={requireNoAuth(Login)} />
                <Route exact path={URLS.LOGIN_WITH_EMAIL} component={requireNoAuth(LoginWithEmail)} />
                <Route exact path={URLS.REGISTRATION} component={requireNoAuth(Register)} />
                <Route exact path={URLS.FORGOT_PASSWORD} component={requireNoAuth(ForgotPassword)} />
                <Route exact path={URLS.RESET_PASSWORD} component={requireNoAuth(ResetPassword)} />
                <Route exact path={URLS.EVENT.PRIZES_LIST} component={PrizesListContainer} />
                <Route exact path={URLS.EVENT.PRIZE} component={PrizeDetailsContainer} />
                <Route exact path={URLS.EVENT.WINNING_TICKET_RESULTS} component={requireAuth(WinningTicket)} />
                <Route exact path={URLS.EVENT.MY_TEAM} component={MyTeam} />
                <Route exact path={URLS.EVENT.TEAM_IMAGE} component={TeamImage} />
                <Route exact path={URLS.EVENT.MOST_POPULAR_PICKS} component={MostPopularPicks} />
                <Route exact path={URLS.EVENT.CHALLENGE_LIST} component={requireAuth(ChallengeListContainer)} />
                <Route exact path={URLS.EVENT.CHALLENGE_DETAILS} component={requireAuth(ChallengeDetailsContainer)} />
                <Route exact path={URLS.EVENT.CREATE_CHALLENGE} component={requireAuth(CreateChallengeContainer)} />
                <Route exact path={URLS.CMS.CMS} component={CmsContainer} />
                <Route path="*" component={reqLayout(Page404)} />
              </Switch>
            </Router>
          </React.Fragment>
        );
      }}
    </CacheBuster>
  );
}

export default App;
